(() => {
  "use strict";

  const ENDPOINT =
    window.SOFAMIX_DRAFT_ENDPOINT ||
    "https://draft.sofamix.ro/iframe_draft_order.php";

  if (!ENDPOINT) return;

  const pickUrl = (d) =>
    d?.draft_order?.checkout_url ||
    d?.checkout_url ||
    d?.draft_order?.invoice_url ||
    d?.invoice_url ||
    null;

  const fetchCart = async () => {
    const r = await fetch("/cart.json", {
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    });
    if (!r.ok) throw new Error("cart.json failed");
    return r.json();
  };

  // Black Friday 2026: -5% la comenzile peste 5.000 lei, fără transport (30.10 10:00 – 1.12 23:59).
  // Reducerea automată din coș e calculată de Shopify pe prețul de catalog al produsului-configurator,
  // iar ciorna o preia ca sumă fixă (și draft.sofamix.ro o respinge). O scoatem și trimitem în loc
  // codul BLACKFRIDAY5 (aceleași reguli), pe care Shopify îl calculează pe prețurile din ciornă.
  // Aceeași regulă e în snippets/smx-bf26-reducere-cos.liquid — schimbă-le împreună.
  const BF26 = {
    title: "Black Friday: -5% la comenzile peste 5.000 lei",
    code: "BLACKFRIDAY5",
    minCents: 500000,
    start: Date.parse("2026-10-30T10:00:00+02:00"),
    end: Date.parse("2026-12-01T23:59:59+02:00")
  };

  const toCents = (value) => {
    const n = parseFloat(String(value).replace(/[^\d,.-]/g, "").replace(",", "."));
    return Number.isFinite(n) ? Math.round(n * 100) : 0;
  };

  const applyBf26 = (cart) => {
    const items = cart.items || [];
    const subtotal = items.reduce((sum, item) => {
      const ip = item.properties && item.properties.__iframe_product_price;
      return sum + (ip ? toCents(ip) * item.quantity : item.final_line_price);
    }, 0);

    const now = Date.now();
    const eligible = now >= BF26.start && now <= BF26.end && subtotal >= BF26.minCents;

    const codes = (cart.discount_codes || []).filter((d) => d.code !== BF26.code);
    if (eligible) codes.push({ code: BF26.code, applicable: true });

    const applications = (cart.cart_level_discount_applications || []).filter(
      (d) => d.title !== BF26.title
    );

    // Ciorna ia reducerea din coș din aceste câmpuri (sau din diferența subtotal − total).
    return Object.assign({}, cart, {
      discount_codes: codes,
      cart_level_discount_applications: applications,
      total_price:
        cart.items_subtotal_price -
        applications.reduce((sum, d) => sum + (d.total_allocated_amount || 0), 0)
    });
  };

  const createDraft = async (cartData) => {
    const r = await fetch(ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(cartData)
    });

    const text = await r.text();
    try {
      return JSON.parse(text);
    } catch {
      return { raw: text };
    }
  };

  const fireGtagBeginCheckout = () => {
    try {
      if (!window.gtag) return;
      // Nu trimitem value aici ca să evităm raportare greșită
      // (prețul configuratorului nu e reflectat în totalurile Shopify)
      window.gtag("event", "begin_checkout", {});
    } catch (e) {}
  };

  // Redirect cu delay 400ms 
  const redirectWithDelay = (url) => {
    const target = url || "/checkout";
    const delay = 400 + Math.floor(Math.random() * 101);
    setTimeout(() => {
      window.location.href = target;
    }, delay);
  };

  const onClick = async (e) => {
    const btn = e.currentTarget;
    e.preventDefault();

    if (btn.__busy) return;
    btn.__busy = true;

    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Se pregătește checkout-ul…";

    // GA4 begin_checkout (buton custom)
    fireGtagBeginCheckout();

    try {
      const cartData = applyBf26(await fetchCart());
      const draftResp = await createDraft(cartData);
      const url = pickUrl(draftResp);

      redirectWithDelay(url);
    } catch (err) {
      redirectWithDelay("/checkout");
    } finally {
      // în caz că nu s-a navigat dintr-un motiv rar
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = original;
        btn.__busy = false;
      }, 2000);
    }
  };

  const bind = (root = document) => {
    root.querySelectorAll(".custom_checkout").forEach((btn) => {
      if (btn.__sofamixBound) return;
      btn.__sofamixBound = true;
      btn.addEventListener("click", onClick);
    });
  };

  document.addEventListener("DOMContentLoaded", () => bind());

  document.addEventListener("shopify:section:load", (e) => bind(e.target));

  const drawer = document.getElementById("cart-drawer");
  if (drawer) {
    const obs = new MutationObserver(() => bind(drawer));
    obs.observe(drawer, { childList: true, subtree: true });
  }
})();
